export default __webpack_public_path__ + "static/william-db3787734874fc2bf1bd9f7cb7d02897.png";